import { GridColDef } from "@mui/x-data-grid";
import { createdAtmodifiedAtActions } from "../../../../../helpers/appHelpers";

export const Columns: GridColDef[] = [
	{
		field: "name",
		headerName: "Name",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "code",
		headerName: "Code",
		minWidth: 180,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "description",
		headerName: "Description",
		minWidth: 400,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "country",
		headerName: "Country",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name || "--",
	},
	{
		field: "active",
		headerName: "Active",
		minWidth: 140,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value ? "Yes" : "No",
	},

	...createdAtmodifiedAtActions
];